import FormModel from '@baidu/ve-ria/views/FormModel';

export default class TemplateFormModel extends FormModel {
    /**
     * @override
     */
    title = ''

    /**
     * @override
     */
    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            text: '新建AR服务'
        }
    ];

    type = 'create';

    /**
     * @override
     */
    init() {
        super.init();

        this.templateRequester = this.api.appServiceARTemplateList;

        this.type = this.getRouteQuery().type;
        if (this.type === 'copy') {
            this.crumbData[1].text = '复制AR服务';
        }
        else if (this.type === 'edit') {
            this.crumbData[1].text = '编辑AR服务';
        }

        this.isAdmin = !!this.getRouteMeta().isAdmin;
        this.crumbData[0].to = this.isAdmin ? '/service/reviewing/list' : '/app/service/list';
    }

    templateList = [];

    page = 1;

    pageSizes = [5, 10];

    total = 10;

    async getTemplateList() {
        const data = await this.templateRequester({
            pageSize: 5,
            pageNo: this.page
        });
        this.page = data.pageNo;
        this.total = data.totalCount;
        this.templateList = data.result || [];
    }
}
